import React, { FunctionComponent, useContext } from "react";
import { useHistory } from "react-router-dom";
import { ListActionButtonProps } from "sprint-common-web";

import { ancillaryAssetsListRoute, getAssetsListRoute } from "../../../../assets/AssetsRoutes";
import { ViewAssetButton } from "../../../common/components/ViewAssetButton";
import { ManageAncillaryContext } from "../../context/ManageAncillaryContext";
import { AncillaryItem } from "../AncillaryItem";

export const ViewAncillaryAssetButton: FunctionComponent<ListActionButtonProps> = (props: ListActionButtonProps) => {
    const history = useHistory();
    const handleClick = () => {
        if (props.itemId) moveToAncillaryAssets(props.itemId);
    };

    const { ancillaryItems, ancillariesToMerge } = useContext(ManageAncillaryContext);

    const mergingInProgress = !!ancillariesToMerge.length;
    const itemToView = ancillaryItems.find((ancillary: AncillaryItem) => ancillary.id === props.itemId);

    const moveToAncillaryAssets = (ancillaryId: string) => {
        const requiredPath = getAssetsListRoute(ancillaryAssetsListRoute.path, ancillaryId);
        history.push(requiredPath);
    };

    return (
        <ViewAssetButton disabled={props.disabled || itemToView?.merged || mergingInProgress} onClick={handleClick} />
    );
};
